module.exports = __webpack_public_path__ + "img/faelPlus.e6394f9b.png";